// extracted by mini-css-extract-plugin
module.exports = {"root":"Gallery_root__BYdpg","wrapper":"Gallery_wrapper__L1kPp","image":"Gallery_image__n7EUS"};